import { FlexBox, IconButton, Skeleton, Tooltip } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { ampli } from 'lib-shared-tracking';
import { memo, useCallback, useMemo } from 'react';

import { useServerStorage } from 'utils/useServerStorage';

import { useQueueDashboardQueueContext } from '../../queueDashboardQueue.context';

export const QueueDashboardQueueFavoriteToggleOld = memo(
  function QueueDashboardQueueFavoriteToggleOld(): JSX.Element {
    const { isSkeleton, ...context } = useQueueDashboardQueueContext();
    const queue = context.queue!;

    const storage = useServerStorage('user');

    const isFavorite = useMemo(
      (): boolean =>
        storage.data.dashboard?.favoriteQueueIds?.includes(queue.id) ?? false,
      [queue.id, storage.data.dashboard?.favoriteQueueIds],
    );

    const handleToggleFavorite = useCallback(() => {
      storage.set({
        dashboard: (draft) => {
          draft.favoriteQueueIds = draft.favoriteQueueIds ?? [];

          if (draft.favoriteQueueIds.includes(queue.id)) {
            draft.favoriteQueueIds = draft.favoriteQueueIds.filter(
              (id) => id !== queue.id,
            );

            ampli.dashboardQueueItemFavoriteToggled({ value: false });
          } else {
            draft.favoriteQueueIds.push(queue.id);
            ampli.dashboardQueueItemFavoriteToggled({ value: true });
          }
        },
      });
    }, [queue, storage]);

    return isSkeleton ? (
      <FlexBox
        justifyContent="center"
        alignItems="center"
        width="32px"
        height="32px"
      >
        <Skeleton height="18px" width="18px" />
      </FlexBox>
    ) : (
      <Tooltip
        content={
          isFavorite ? 'Remove from my favorites' : 'Add to my favorites'
        }
        disabled={isSkeleton}
      >
        <IconButton
          variant="tertiary"
          icon={isFavorite ? 'star-full' : 'star'}
          iconProps={{
            color: isFavorite ? colors.orange[300] : colors.neutral[400],
          }}
          onClick={handleToggleFavorite}
        />
      </Tooltip>
    );
  },
);
